import {useCallback} from 'react';

import {AxiosResponse} from 'axios';
import {useDispatch} from 'react-redux';

import {DeclineType} from 'libs/checkout/requests/getPaymentDeclineCode';
import {flags} from 'libs/rollout';

import {INSUFFICIENT_FUNDS} from '../../components/bnplOfferPopup/bnplOfferPupupList/constant';
import {setPlaceOrderErrors} from '../../store/actions/completeOrder/completeOrder';
import {setAnalyticsMessage, setUiMessage} from '../../store/reducers/primer/primer';

/**
 * Handle decline response from Primer
 */
export const useHandleDecline = () => {
    const dispatch = useDispatch();

    const handleDecline = useCallback(
        (response: AxiosResponse<DeclineType>) => {
            const {
                data: {code, friendlyMessage, preAuthorizationResult, title},
            } = response;
            if (code === INSUFFICIENT_FUNDS && flags.checkoutInsufficientFundsOffer.isEnabled())
                dispatch(setPlaceOrderErrors([{code: INSUFFICIENT_FUNDS, friendlyMessage, title}]));
            else dispatch(setUiMessage(friendlyMessage));

            dispatch(
                setAnalyticsMessage(
                    preAuthorizationResult === 'ACCEPT'
                        ? `${code || 'empty code'}, ${title || 'empty title'}`
                        : 'empty code, Declined by Riskified',
                ),
            );
        },
        [dispatch],
    );

    return handleDecline;
};
